import { configs } from '../../../../constants/configs/configs';

const {
    states: {
        PENNSYLVANIA,
        NEW_JERSEY,
        NEW_MEXICO,
        GEORGIA,
        VIRGINIA,
        GETINSURED
    }
} = configs;
export const ACCESSCODE_PAGE_PREFERENCE = [
    {
        value: 'accessCode',
        text: 'accounts.accessCode.have_accessCode'
    },
    {
        value: 'ssn',
        text: 'accounts.accessCode.have_ssn'
    }
];

export const EDE_SEARCH = {
    [GEORGIA]: [
        {
            value: 'ssn',
            text: 'selfDesignation.search.radio-option.ssn'
        },
        {
            value: 'name',
            text: 'selfDesignation.search.radio-option.name'
        }
    ],
    [NEW_JERSEY]: [
        {
            value: 'ssn',
            text: 'selfDesignation.search.radio-option.ssn'
        }
    ],
    [NEW_MEXICO]: [
        {
            value: 'ssn',
            text: 'selfDesignation.search.radio-option.ssn'
        }
    ],
    [PENNSYLVANIA]: [
        {
            value: 'ssn',
            text: 'selfDesignation.search.radio-option.ssn'
        }
    ],
    [VIRGINIA]: [
        {
            value: 'ssn',
            text: 'selfDesignation.search.radio-option.ssn'
        },
        {
            value: 'name',
            text: 'selfDesignation.search.radio-option.name'
        }
    ],
    [GETINSURED]: [
        {
            value: 'ssn',
            text: 'selfDesignation.search.radio-option.ssn'
        }
    ]

};

export const SELECT_OPTIONS = {
    ACCESSCODE_PAGE_PREFERENCE,
    EDE_SEARCH
};